import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    description:
      "Welcome to Apartments Gavranović! Discover your perfect seaside escape in the charming town of Malinska. Our cozy, modern apartment is nestled on a quiet street, offering you a peaceful retreat just a two-minute stroll (less than 200 meters) from the crystal-clear Adriatic Sea. While you'll enjoy the tranquility of our neighborhood, you're only moments away from the vibrant atmosphere of the town center. Experience the best of both worlds: a quiet haven after a long day of swimming and exploring, yet close enough to enjoy local shops, restaurants, and promenades whenever you wish.",

    location: "Our Location",
    Bathroom: "Bathroom",
    Bedroom: "Bedroom",
    Guests: "Guests",

    /* NEARBY */
    Nearby: "Nearby & Distances",
    sea: "Sea",
    beach: "Beach",
    bar: "Bar",
    shop: "Closest shop",
    restaurant: "Restaurants",
    city: "City center",
    pharmacy: "Pharmacy",

    /* PRICING */
    Pricing: "Seasonal Pricing",
    season: "Season",
    period: "Period",
    price: "Price / Night",

    preseason: "Pre-season",
    postseason: "Postseason",
    peakseason: "Peak season"
  },

  hr: {
    description:
      "Dobrodošli u Apartmane Gavranović! Otkrijte svoj savršeni bijeg uz more u šarmantnom gradiću Malinskoj. Naš ugodni, moderni apartman smješten je u mirnoj ulici, nudeći vam mirno utočište na samo dvije minute šetnje (manje od 200 metara) od kristalno čistog Jadranskog mora. Dok ćete uživati ​​u miru našeg susjedstva, samo ste nekoliko trenutaka udaljeni od živahne atmosfere centra grada. Doživite najbolje od oba svijeta: mirno utočište nakon dugog dana plivanja i istraživanja, a opet dovoljno blizu da uživate u lokalnim trgovinama, restoranima i šetnicama kad god poželite.",

    location: "Naša lokacija",
    Bathroom: "Kupaonica",
    Bedroom: "Soba",
    Guests: "Ljudi",

    /* U BLIZINI */
    Nearby: "U blizini",
    sea: "More",
    beach: "Plaža",
    bar: "Bar",
    shop: "Najbliža trgovina",
    restaurant: "Restorani",
    city: "Centar grada",
    pharmacy: "Ljekarna",

    /* CJENIK */
    Pricing: "Cjenik",
    season: "Sezona",
    period: "Razdoblje",
    price: "Cijena / noć",

    preseason: "Predsezona",
    postseason: "Posezona",
    peakseason: "Glavna sezona"
  },

  sl: {
    description:
      "Dobrodošli v apartmajih Gavranović! Odkrijte svoj popoln pobeg ob morju v očarljivem mestecu Malinska. Naš prijeten, sodoben apartma se nahaja v mirni ulici in vam ponuja miren umik, le dve minuti hoje (manj kot 200 metrov) od kristalno čistega Jadranskega morja. Medtem ko boste uživali v miru naše soseske, ste le nekaj trenutkov oddaljeni od živahnega vzdušja mestnega središča. Doživite najboljše iz obeh svetov: mirno zatočišče po dolgem dnevu plavanja in raziskovanja, a hkrati dovolj blizu, da lahko kadar koli uživate v lokalnih trgovinah, restavracijah in sprehajališčih.",

    location: "Naša lokacija",
    Bathroom: "Kopalnica",
    Bedroom: "Spalnica",
    Guests: "Gostje",

    Nearby: "V bližini",
    sea: "Morje",
    beach: "Beach",
    bar: "Bar",
    shop: "Najbližja trgovina",
    restaurant: "Restavracije",
    city: "Središče mesta",
    pharmacy: "Farmacija",

    Pricing: "Cenik",
    season: "Sezona",
    period: "Obdobje",
    price: "Cena / noč",

    preseason: "Predsezona",
    postseason: "Posezona",
    peakseason: "Visoka sezona"
  },

  it: {
    description:
      "Benvenuti agli Appartamenti Gavranović! Scoprite la vostra perfetta fuga al mare nell'incantevole cittadina di Malinska. Il nostro accogliente e moderno appartamento è situato in una strada tranquilla, offrendovi un rifugio tranquillo a soli due minuti a piedi (meno di 200 metri) dalle acque cristalline del Mar Adriatico. Godetevi la tranquillità del nostro quartiere, ma allo stesso tempo siete a pochi passi dalla vivace atmosfera del centro città. Vivete il meglio di entrambi i mondi: un rifugio tranquillo dopo una lunga giornata di nuoto ed esplorazione, ma abbastanza vicino da potervi godere negozi, ristoranti e passeggiate locali ogni volta che lo desiderate.",

    location: "La nostra posizione",
    Bathroom: "Bagno",
    Bedroom: "Camera da letto",
    Guests: "Ospiti",

    Nearby: "Nelle vicinanze",
    sea: "Mare",
    beach: "Spiaggia",
    bar: "Sbarra",
    shop: "Negozio più vicino",
    restaurant: "Ristoranti",
    city: "Centro città",
    pharmacy: "Farmacia",

    Pricing: "Listino prezzi",
    season: "Stagione",
    period: "Periodo",
    price: "Prezzo / notte",

    preseason: "Bassa stagione",
    postseason: "Post-stagione",
    peakseason: "Alta stagione"
  },

  de: {
    description:
      "Willkommen in den Apartments Gavranović! Entdecken Sie Ihren perfekten Urlaub am Meer im charmanten Städtchen Malinska. Unser gemütliches, modernes Apartment liegt in einer ruhigen Straße und bietet Ihnen eine Oase der Ruhe – nur zwei Gehminuten (weniger als 200 Meter) vom kristallklaren Wasser der Adria entfernt. Genießen Sie die Ruhe unserer Nachbarschaft und erreichen Sie gleichzeitig in wenigen Minuten das lebhafte Stadtzentrum. Erleben Sie das Beste aus beiden Welten: eine Oase der Ruhe nach einem langen Tag voller Schwimmen und Erkundungen und dennoch die Nähe zu Geschäften, Restaurants und Promenaden, wann immer Sie möchten.",

    location: "Unser Standort",
    Bathroom: "Badezimmer",
    Bedroom: "Schlafzimmer",
    Guests: "Gäste",

    Nearby: "In der Nähe",
    sea: "Meer",
    beach: "Strand",
    bar: "Bar",
    shop: "Nächstes Geschäft",
    restaurant: "Restaurants",
    city: "Stadtzentrum",
    pharmacy: "Apotheke",

    Pricing: "Preisliste",
    season: "Saison",
    period: "Zeitraum",
    price: "Preis / Nacht",

    preseason: "Vorsaison",
    postseason: "Nachsaison",
    peakseason: "Hochsaison"
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n

